import React from "react"
import logoImg from "../assets/logo.png";
import { rhythm, scale } from "../utils/typography"
require("typeface-roboto");

class Layout extends React.Component {
  render() {
    const { children } = this.props;
    const header = (
      <Navbar/>
    );
    return (
      <div
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: rhythm(24),
          padding: `0 ${rhythm(3 / 4)} ${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}
      >
        <header>{header}</header>
        <main>{children}</main>
        <footer
          style={{
            fontFamily: "Roboto",
            fontWeight: 800,
            ...scale(-0.5),
            marginBottom: rhythm(0.5)
          }}
        >
          © {new Date().getFullYear()} Cerah <a href="https://www.cerah.co">www.cerah.co</a>
        </footer>
      </div>
    )
  }
}

function Navbar() {
  return (
    <nav
      style={{
        padding: rhythm(0.5),
        height: rhythm(2),
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "white",
        boxShadow: `#ccc 0 0px 5px`,
        zIndex: 1000
      }}
    >
      <a href="../../cerahOnline">
      <img
        style={{
          height: "100%"
        }}
        alt="Cerah"
        src={logoImg}/>
      </a>
    </nav>
  );
}

export default Layout;
